// Vendor imports
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { CheckExperiment } = require('client-v2/common/containers/rollouts')
const useStickyfill = require('client-v2/common/hooks/stickyfill')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('TopCallToActionJumpToGrid')

function TopCallToActionJumpToGridDiscover(props) {
  return tag('a', {
    ref: useStickyfill(),
    className: bem.block(),
    href: props.href
  },
    'Discover your next favorite thing'
  )
}

function TopCallToActionJumpToGridExplore(props) {
  return tag('a', {
    ref: useStickyfill(),
    className: bem.block(),
    href: props.href
  },
    'Explore Top Picks on Mix'
  )
}

function TopCallToActionJumpToGrid(props) {
  return tag(CheckExperiment, {
    experimentKey: '*logged_out_top_cta',
    renderWithModifier: modifier => {
      if (modifier === 'c') {
        return null
      }
      if (modifier === 'b') {
        return tag(TopCallToActionJumpToGridExplore, props)
      }
      return tag(TopCallToActionJumpToGridDiscover, props)
    }
  })
}

module.exports = TopCallToActionJumpToGrid
